import React, { FC } from 'react';

import { ICategory, ICategoryItem } from '../../../common/messageCreators';
import { useIsSmallScreen, useUserActionClickCategory } from '../../hooks';
import { ButtonLinkWrapper } from '../ButtonLinkWrapper/ButtonLinkWrapper';
import { ButtonContent } from '../Buttons';
import { ButtonsGrid } from '../ButtonsGrid/ButtonsGrid';
import { MessageItem } from '../MessageItem';

export const Category: FC<ICategory> = ({ type, id, items }) => {
  const emit = useUserActionClickCategory();
  const isSmallScreen = useIsSmallScreen();

  const onClick = (item: ICategoryItem, position: number) => {
    emit(type, {
      label: item.title,
      position,
      item,
    });
  };

  const columnsCount = isSmallScreen || items.length === 1 ? 1 : 2;

  const categoryButtons = items
    .filter((i) => !i.hidden)
    .map((item, index) => {
      return (
        <ButtonLinkWrapper
          key={item._id}
          onClick={() => onClick(item, index)}
          link={item.link}
          data-chatbot-category={item._id}
          data-hook="item"
        >
          <ButtonContent label={item.title} sublabel={item.subtitle} icon={item.icon} />
        </ButtonLinkWrapper>
      );
    });

  return (
    <MessageItem id={id} width={isSmallScreen ? 'standard' : 'full'}>
      <ButtonsGrid columnsCount={columnsCount}>{categoryButtons}</ButtonsGrid>
    </MessageItem>
  );
};
